import { Drawer, Empty, List, Tag, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { intelligenceService } from '@/services/intelligence.service';

const { Text, Paragraph } = Typography;

export function RelationshipExplorer(props: {
  open: boolean;
  onClose: () => void;
  entityType: string;
  entityId: string;
}) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['intelligence-relationship', props.entityType, props.entityId],
    queryFn: () => intelligenceService.getRelationship(props.entityType, props.entityId),
    enabled: props.open && !!props.entityType && !!props.entityId,
    staleTime: 60_000,
  });

  return (
    <Drawer
      title={`Relationships · ${props.entityType}`}
      open={props.open}
      onClose={props.onClose}
      width={480}
      placement="right"
    >
      {isLoading ? (
        <Paragraph type="secondary">Loading graph…</Paragraph>
      ) : isError || !data ? (
        <Empty description="Relationship graph unavailable" />
      ) : (
        <>
          <Paragraph type="secondary">
            {data.nodes.length} nodes · {data.edges.length} edges
          </Paragraph>
          <List
            size="small"
            header={<Text strong>Nodes</Text>}
            dataSource={data.nodes}
            renderItem={(n) => (
              <List.Item>
                <Tag>{n.type}</Tag>
                <Text>{n.label}</Text>
              </List.Item>
            )}
          />
          <List
            size="small"
            style={{ marginTop: 16 }}
            header={<Text strong>Edges</Text>}
            dataSource={data.edges}
            renderItem={(e) => (
              <List.Item>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {e.from.slice(0, 8)} —[{e.relation}]→ {e.to.slice(0, 8)}
                </Text>
              </List.Item>
            )}
          />
        </>
      )}
    </Drawer>
  );
}
